import React from "react"
import { TextField, InputAdornment } from "@mui/material"
import { COLORS } from "../../utils"

const FormikNumberField = ({
  label,
  name,
  value,
  onChange,
  onBlur,
  disabled = false,
  endAdornment = "%",
  sx = {}
}) => {
  return (
    <TextField
      variant="standard"
      label={label}
      name={name}
      value={value ?? ""}
      onChange={onChange}
      onBlur={onBlur}
      disabled={disabled}
      InputProps={{
        endAdornment: 
        <InputAdornment position="end">
          <span style={{ fontSize: "16px", color: COLORS.BLACK_400 }}>{endAdornment}</span>
        </InputAdornment>,
        inputMode: "numeric",
        pattern: "[0-9]*"
      }}
      InputLabelProps={{ shrink: true }}
      sx={{
        "& .MuiInputBase-input": {
          fontSize: "14px",
          color: COLORS.BLACK800
        },
        "& .MuiInputLabel-root": {
          fontSize: "12px",
          color: COLORS.BLACK_500
        },
        ...sx
      }}
    />
  )
}

export default FormikNumberField